import React, { useEffect, useRef, useState } from 'react';
import { Hero } from './components/Hero';
import { Countdown } from './components/Countdown';
import { Mirror } from './components/Mirror';
import { Transformation } from './components/Transformation';
import { ForYou } from './components/ForYou';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Closing } from './components/Closing';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
import { useCheckoutUrl } from './hooks/useCheckoutUrl';
import { scrollToCheckout } from './utils/scroll';
export function App() {
  const checkoutUrl = useCheckoutUrl();
  const heroRef = useRef<HTMLElement>(null);
  const [heroVisible, setHeroVisible] = useState(true);
  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => setHeroVisible(entry.isIntersecting), {
      threshold: 0
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans" data-id="element-0" data-mp="3rcj7c4kla37o">
      <main className="mx-auto w-full max-w-[480px] overflow-hidden bg-ink pb-20 shadow-[0_0_80px_rgba(92,10,20,0.35)]" data-id="element-1" data-mp="3rd191gq0t9mz">
        <Hero ref={heroRef} onCtaClick={scrollToCheckout} data-id="element-2" data-mp="7sxpp6lk59z" />
        <Countdown data-id="element-3" data-mp="2zmo4r67q0h12" />
        <Mirror data-id="element-4" data-mp="2zn6aquk6q9m6" />
        <Transformation data-id="element-5" data-mp="33mou3lwcycmw" />
        <ForYou data-id="element-6" data-mp="33m5eibu6k0c1" />
        <Testimonials data-id="element-7" data-mp="33nq55qddiz4m" />
        <Offer checkoutUrl={checkoutUrl} data-id="element-8" data-mp="33mymth8sexwa" />
        <Guarantee data-id="element-9" data-mp="38m1fe27kzbnd" />
        <Faq data-id="element-10" data-mp="38li6fazwrxlh" />
        <Closing data-id="element-11" data-mp="38l05w267qx7r" />
        <Footer data-id="element-12" data-mp="38kgmsi4tu2s5" />
      </main>
      <StickyBar visible={!heroVisible} data-id="element-13" data-mp="3dkuwe4m2tksa" />
    </div>;
}